import API from '../axios'

export const apiStaff = {
  list: async () => {
    return API.get('/staff/get-all-staff')
  }
}

export const apiSubmitForm = {
  submitGoogleForm: async (data: any) => {
    return API.post('/submit-form/google-form', data)
  }
}

export const apiAuthentication = {
  loginByToken: async (token: string) => {
    try {
      const result = await API.get(`/auth/get-profile`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      return result
    } catch (error) {
      throw new Error('Can not login by token')
    }
  }
}
